import React from 'react';
import "./Footer.scss"
import {Link} from "react-router-dom";
import logoStacked from "../assets/images/logos/logo_stacked_white.svg"
import logoSvg from "../assets/images/logos/logo_only_secondary.svg"
import {HiMiniArrowSmallRight} from "react-icons/hi2";
const FooterMinimal = () => {
    return (
        <div className={"footer-container"}>
            <img alt="" src={logoSvg} className={"footer-svg"}/>
            <div className="footer-card container-fluid">

                
                <div className="row">
                    <div className="col-12 col-md-6 d-flex justify-content-center mb-4 mb-md-0">
                        <div className="footer-logo-stacked-container">
                            <img src={logoStacked} alt="Arkham Law" className="footer-logo-stacked"/>
                        </div>
                    </div>


                    <div className="col-12 col-md-3 text-start mb-4 mb-md-0">
                        <h4 className="footer-label">Services</h4>
                        <ul className="list-unstyled">
                            <li>
                                <Link to="/services#immigration" className="footer-link">
                                    Immigration Law <HiMiniArrowSmallRight className="link-icon"/>
                                </Link>
                            </li>
                            <li>
                                <Link to="/services#residential" className="footer-link">
                                    Real Estate Law <HiMiniArrowSmallRight className="link-icon"/>
                                </Link>
                            </li>
                            <li>
                                <Link to="/services#commercial" className="footer-link">
                                    Commercial Law <HiMiniArrowSmallRight className="link-icon"/>
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="col-12 col-md-3 text-start">
                        <h4 className="footer-label">Support</h4>
                        <ul className="list-unstyled">
                            <li>
                                <Link to="/about" className="footer-link">
                                    About Us <HiMiniArrowSmallRight className="link-icon"/>
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact" className="footer-link">
                                    Contact Us <HiMiniArrowSmallRight className="link-icon"/>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="footer-border"></div>
            <div className="copyright">
                © 2026 Arkham Law
            </div>
        </div>
    );
};

export default FooterMinimal;
